import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import PropTypes from "prop-types";

const CustomSelect = ({ label, width, value, options, valueKey, onChange }) => {
	const sx = {
		color: "black.main",
	};

	return (
		<FormControl
			sx={{
				width: width ? width : 220,
			}}
		>
			<InputLabel>{label}</InputLabel>
			<Select sx={sx} value={value} label={label} onChange={onChange}>
				{options.map((item, index) => {
					return (
						<MenuItem key={index} value={item[valueKey]}>
							{item[valueKey]}
						</MenuItem>
					);
				})}
			</Select>
		</FormControl>
	);
};

CustomSelect.propTypes = {
	label: PropTypes.string.isRequired,
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
		PropTypes.bool,
	]).isRequired,
	options: PropTypes.array.isRequired,
	valueKey: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
};

export default CustomSelect;
